import styled from "styled-components";
import Base from "../base/index";

const Title = styled(Base.withComponent("h1"))`
  color: var(--Gray-08, #48454c);
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: ${(props) => (props.fontSize ? `${props.fontSize};` : "2rem")};
`;

export default Title;
